import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import AI from "../views/AI.vue";
import Gallery from "../views/Gallery.vue";
import GalleryItem from "../views/GalleryItem.vue";
import DesignRoom from "../views/DesignRoom.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/ai",
    name: "AI",
    component: AI,
  },
  {
    path: "/gallery",
    name: "Gallery",
    component: Gallery,
  },
  {
    path: "/galleryitem/:id",
    name: "GalleryItem",
    component: GalleryItem,
  },
  {
    path: "/designroom",
    name: "DesignRoom",
    component: DesignRoom,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
